var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25.0627C50 11.2281 38.8 0 25 0C11.2 0 0 11.2281 0 25.0627C0 37.193 8.6 47.2932 20 49.6241V32.5815H15V25.0627H20V18.797C20 13.9599 23.925 10.0251 28.75 10.0251H35V17.5439H30C28.625 17.5439 27.5 18.6717 27.5 20.0501V25.0627H35V32.5815H27.5V50C40.125 48.7469 50 38.0702 50 25.0627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.54102168530586f1df51c1a7a58232a6.svg";
export { ForwardRef as ReactComponent };